import styles from './banner.module.scss';

type BannerType = 'info' | 'warning';

interface BannerProps {
  type: BannerType;
  text1: string;
  text2?: string;
}

export default function Banner({ text1, text2 = '', type }: BannerProps) {
  const rootClassName = `${styles.banner} ${styles[type]}`.trim();

  return (
    <div className={rootClassName}>
      <div className={styles.text1}>{text1}</div>
      {text2 && <div className={styles.text2}>{text2}</div>}
    </div>
  );
}
